export default {
  voucher: {
    title: '嵯峨野トロッコ列車乗車票',
    info: {
      voucherNumber: 'チケット番号',
      date: '利用日',
      time: '発車時間',
      serviceName: '列車名',
      userNumber: '乗車人数',
      seat: '座席',
      agentName: '代理店名',
      agentSubGroupName: '営業所名',
      groupName: '団体名',
      groupNameValue: '{{groupName}}　様',
      tip: '特記事項',
      notice: '注意事項',
      total: '合計 ',
      people: '名',
      station: 'トロッコ',
      seatsTips: `
      詳細は下記座席表を参照願います`,
      noticeValue: `乗車当日は発車20分前までに手続きをお願いします。
        緊急の際は075-871-3997までご連絡をお願いします。
        トロッコ列車は全車指定席。
        全車禁煙です。
        `
    },
    qrCode: {
      title: '二次元バーコード \n（嵯峨野トロッコ業務用）',
      tip: 'チケットの利用方法',
      step1: 'STEP01',
      step1Tip: 'この乗車票を印刷する',
      step2: 'STEP02',
      step2Tip: '駅の窓口に発車20分前に受付を完了してください',
      step3: 'STEP03',
      step3Tip: '座席表を確認してお座り下さい'
    },
    carsTitle: '座席表',
    carsTip: '※座席番号が記載されているところが選択されている座席です。',
    carsDirectionDown: '← トロッコ亀岡方面',
    carsDirectionUp: 'トロッコ嵯峨方面 →',
    arrangementPattern: {
      carName: '車両',
      car1: '1号車',
      car2: '2号車',
      car3: '3号車',
      car4: '4号車',
      car5: 'リッチ号/5号車'
    }
  },
  invoice: {
    title: '請求書',
    paymentType: {
      PREPAID: '(クレジットカード支払い)',
      COUPON: '（船車券発行）',
      MONTHLY: '（銀行振込）',
      CASH: '現金',
      OTHER: 'その他'
    },
    info: {
      title: '{{agentName}} 御中',
      tip: '毎々格別のお引き立てを賜り、誠にありがとうございます。下記の通り、ご請求申し上げます。'
    },
    infoDate: {
      COUPON: 'お支払い期限',
      PREPAID: 'お支払い期限'
    },
    bill: {
      title: 'ご請求金額（税込）',
      people: '人数合計',
      groupType: '団体区分',
      date: '利用日',
      time: '乗車時刻',
      trainName: '列車名'
    },
    table: {
      allAmount: '総額 (1)+(2)（税込）',
      cancelAllAmount: '総額 (2)+(3)（税込）',
      total: '合計',
      allPaidAmount: 'お支払い済額',
      taxDiff: '税率区分',
      tax: '消費税',
      amount: '金額（税込）',
      memo: '備考'
    },
    tax: '消費税額',
    groupType: {
      NORMAL: '一般団体',
      SCHOOL: '学生団体'
    },
    taxDetail: '税金詳細',
    agent: {
      date: '発行日',
      invoiceId: '請求番号',
      corporateNumber: '登録番号',
      postalCode: '〒',
      address: '住所',
      phone: '電話',
      fax: 'FAX'
    }
  },
  seat: {
    wheelchairPair: {
      primaryTitle: '您已选择轮椅专用座位（{{seat}}）。',
      supporterTitle: '您已选择轮椅陪同座位（{{seat}}）。',
      yes: '是',
      cancel: '取消',
      lead: '请确认以下事项。',
      consideration:
        '此座位是为使用轮椅的乘客及其陪同人员准备的，敬请予以关照。',
      contact:
        '致预订轮椅专用座位的乘客\n乘车前有一些事项需要向您确认。请阅读本公司网站或预订确认邮件中的「致身体不便的乘客」后与我们联系。',
      spaceFull: '※轮椅空间已满时，我们将在支付页面通知您，敬请谅解。',
      continue: '要就这样继续选择吗？'
    },
    parenthesis: '（{{text}}）',
    header: {
      station: '请输入订购信息',
      seat: '请选择车厢及座位',
      start: '{{time}}出发',
      confirm: '请确认购买信息',
      orderConfirm: '座位确认',
      orderConfirmTip: '※仅在支付完成且预订完成后，座位才会正式确认。'
    },
    button: {
      back: '回退',
      next: '下一步'
    },
    selectSeatType: {
      title: '选位方法',
      auto: '电脑选位',
      manual: '自行选位'
    },
    station: {
      date: '乘车日',
      startStation: '出发站',
      endStation: '抵达站',
      startStationTip: '请选择出发站',
      endStationTip: '请选择抵达站'
    },
    hintType: {
      OUT_OF_AVAILABLE_TERM:
        '所选日期尚未开放预订。 （仅可预订1个月内的车次。）',
      END_OF_SERVICE: '本日营运已结束。'
    },
    train: {
      header: '请选择小火车',
      emptySeat: '空座位'
    },
    carriage: {
      carriage1: '1号车厢',
      carriage2: '2号车厢',
      carriage3: '3号车厢',
      carriage4: '4号车厢',
      carriage5: '富贵5号车厢',
      directionUpTitle: '↑ 往小火车嵯峨站方向',
      directionDownTitle: '↑ 往小火车龟冈站方向'
    },
    baseCar: {
      front: '驾驶室',
      entrance: '出入口'
    }
  },
  receipt: {
    title: '領収書',
    name: '御中',
    number: 'No.',
    issueData: '発行日',
    amountTips: '但、嵯峨野トロッコ利用料として\n上記正に領収いたしました。',
    price: '金額',
    priceUnit: '￥{{price}}',
    afterTax: '（税込）',
    afterTaxPrice: '税抜金額',
    taxPrice: '消費税等',
    issuer: `{{name}}\n〒{{postalCode}}\n{{address}}\n電話：{{phoneNumber}}`,
    chargeTips: '※内訳は請求書を参照願います。',
    tips: '＊A4縦に印刷し、下部の余白は切ってお使いください'
  },
  cancellationPolicy: {
    title: 'キャンセルポリシー'
  }
};
